import styled from 'styled-components';
import { PropertyCardMLSFooterMixin } from '../../mixins/components/PropertyCardMLSFooterMixin';
export var StyledPropertyCardMLSFooter = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardMLSFooter",
  componentId: "c11n-8-111-1__sc-nrh0so-0"
})(["", ""], PropertyCardMLSFooterMixin);